// AQ monogram: the A's crossbar is an emerald upward arrow (growth / good standing); the Q tail is an emerald accent.
const MARK = {
  a: "M10 47 L21.5 17 L33 47",
  arrow: "M17.8 42 L21.5 37.5 L25.2 42",
  q: { cx: 45, cy: 33, r: 8.5 },
  tail: "M46.5 35.5 L54 44.5",
};

export const AQMark = ({ size = 32, className = "", tile = true, testId = "brand-mark" }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} className={className} data-testid={testId} role="img" aria-label="AccruallQ">
    {tile && <rect width="64" height="64" rx="15" fill="#0F172A" />}
    {tile && <rect x="0.75" y="0.75" width="62.5" height="62.5" rx="14.25" fill="none" stroke="#10B981" strokeOpacity="0.45" strokeWidth="1.5" />}
    <path d={MARK.a} fill="none" stroke={tile ? "#FFFFFF" : "currentColor"} strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d={MARK.arrow} fill="none" stroke="#10B981" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
    <circle {...MARK.q} fill="none" stroke={tile ? "#FFFFFF" : "currentColor"} strokeWidth="5" />
    <path d={MARK.tail} stroke="#10B981" strokeWidth="5" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ className = "", size = 32, tagline = false, invert = false }) => (
  <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <AQMark size={size} />
    <div className="leading-none">
      <span className={`font-display text-lg font-extrabold tracking-tight ${invert ? "text-white" : ""}`}>
        Accruall<span className="text-emerald-500">Q</span>
      </span>
      {tagline && (
        <div className={`hidden sm:block text-[10px] uppercase tracking-[0.18em] mt-1 font-semibold ${invert ? "text-slate-400" : "text-muted-foreground"}`} data-testid="brand-tagline">
          Corporate Health Operating System
        </div>
      )}
    </div>
  </div>
);
